// LiveStreamEarnings.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LiveStreamGiftDiamond from '../component/LiveStreamGiftDiamond.jsx';
import trackMixpanel, {
  EventTypes,
  getViewId,
  ButtonId,
} from '../resource/mixpanel.js';

export class LiveStreamEarnings extends React.PureComponent {
  trackUserClick = buttonId => {
    trackMixpanel({
      type: EventTypes.USER_CLICKED,
      payload: {
        viewId: getViewId({
          pathname: window.location.pathname,
        }),
        buttonId,
      },
    });
  };
  openGiftLeaderboard = () => {
    const { openModal } = this.props;
    this.trackUserClick(ButtonId.LiveStream.ButtonGiftLeaderboard);
    openModal({ id: 'LiveStreamGiftLeaderboard' });
  };
  render() {
    const {
      giftDiamondCount,
      viewDiamondCount,
      karaokeDiamondCount,
      showDiamondCount,
    } = this.props;
    const totalDiamondCount =
      giftDiamondCount +
      viewDiamondCount +
      karaokeDiamondCount +
      showDiamondCount;
    return (
      <StyledLiveStreamEarnings onClick={this.openGiftLeaderboard}>
        <LiveStreamGiftDiamond giftDiamondCount={totalDiamondCount} />
      </StyledLiveStreamEarnings>
    );
  }
}

LiveStreamEarnings.propTypes = {
  giftDiamondCount: PropTypes.number,
  viewDiamondCount: PropTypes.number,
  karaokeDiamondCount: PropTypes.number,
  showDiamondCount: PropTypes.number,
  openModal: PropTypes.func,
};

LiveStreamEarnings.defaultProps = {
  giftDiamondCount: 0,
  viewDiamondCount: 0,
  karaokeDiamondCount: 0,
  showDiamondCount: 0,
  openModal: () => null,
};

const StyledLiveStreamEarnings = styled.div``;

export default LiveStreamEarnings;
